import uni from "../styles/univesal.module.css";
import { error, checkbox, logo } from "./common";
import { Check } from "../types";
import { LangIds, Languages, getLang } from "../langs/langs";
import { useState } from "react";

interface Props {
  lang: Languages;
  onAccept: () => void;
}

function AcceptTerms({lang, onAccept}: Props) {
  const [checkTerms, setCheckTerms] = useState<Check>(Check.UNCHECKED);
  const [checkShare, setCheckShare] = useState<Check>(Check.UNCHECKED);
  
  const handleCheckTerms = () => {
    if(checkTerms === Check.CHECKED)
      setCheckTerms(Check.UNCHECKED);
    else
      setCheckTerms(Check.CHECKED);
  }

  const handleCheckShare = () => {
    if(checkShare === Check.CHECKED)
      setCheckShare(Check.UNCHECKED);
    else
      setCheckShare(Check.CHECKED);
  }

  const handleClick = () => {
    if(checkTerms !== Check.CHECKED){
      setCheckTerms(Check.EMPHASIZED);
      const element = document.getElementById("checkTermsSpacer");
      if(element)
        element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
      return;
    }

    onAccept();
  }
  return (
    <>
    <div className={uni.container}>
      <div className={uni.bigText}>{getLang(LangIds.ACCEPT_Lets, lang)}</div>
      <div className={uni.spacerBig}/>
      <div className={uni.mediumText}>{getLang(LangIds.ACCEPT_First, lang)}</div>
      <div className={uni.spacer}/>

      <div className={uni.innerCenterFlexContainer}>
        <svg width="174" height="174" viewBox="0 0 174 174" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M159.5 89.9C159.5 128.47 128.47 159.5 89.9 159.5C51.33 159.5 20.3 128.47 20.3 89.9C20.3 51.33 51.33 20.3 89.9 20.3C128.47 20.3 159.5 51.33 159.5 89.9Z" fill="#EAECEE"/>
        <path d="M97.4023 126.69C99.0201 121.659 95.6347 116.069 89.8406 114.207C84.0466 112.344 78.0381 114.912 76.4202 119.944C74.8024 124.976 78.1878 130.565 83.9819 132.428C89.7759 134.291 95.7844 131.722 97.4023 126.69Z" fill="white" stroke="#808DA0" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M84.39 104.69L51.62 114.26C46.98 115.71 42.34 113.1 41.18 108.46L33.06 80.6199C31.61 75.9799 34.22 71.34 38.86 70.18L74.53 59.45C75.4 59.45 82.07 66.99 83.23 71.63L85.55 78.0099L86.42 91.3499L84.39 104.69Z" fill="white" stroke="#808DA0" strokeMiterlimit="10"/>
        <path d="M66.7 76.27C72.79 74.53 76.85 73.37 82.94 71.34L66.7 76.27Z" fill="#E6E8EC"/>
        <path d="M66.7 76.27C72.79 74.53 76.85 73.37 82.94 71.34" stroke="#808DA0" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M68.15 81.4899C74.24 79.7499 78.3 78.5899 84.39 76.5599L68.15 81.4899Z" fill="#E6E8EC"/>
        <path d="M68.15 81.4899C74.24 79.7499 78.3 78.5899 84.39 76.5599" stroke="#808DA0" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M69.89 87C75.98 85.26 79.46 84.1 85.55 82.36L69.89 87Z" fill="#E6E8EC"/>
        <path d="M69.89 87C75.98 85.26 79.46 84.1 85.55 82.36" stroke="#808DA0" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M71.34 92.5099C77.43 90.7699 79.46 90.1899 85.84 88.1599L71.34 92.5099Z" fill="#E6E8EC"/>
        <path d="M71.34 92.5099C77.43 90.7699 79.46 90.1899 85.84 88.1599" stroke="#808DA0" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M51.91 89.61C54.6327 89.61 56.84 87.4028 56.84 84.68C56.84 81.9572 54.6327 79.75 51.91 79.75C49.1872 79.75 46.98 81.9572 46.98 84.68C46.98 87.4028 49.1872 89.61 51.91 89.61Z" stroke="#808DA0" strokeMiterlimit="10"/>
        <path d="M53.36 89.61C48.72 91.06 46.11 95.7 47.56 100.34L64.09 95.41C62.93 90.77 58 88.16 53.36 89.61Z" stroke="#808DA0" strokeMiterlimit="10"/>
        <path d="M98.31 150.51L70.76 65.83L69.89 63.22C67.57 55.97 71.63 48.72 78.88 46.4L130.5 29.87C130.5 29.87 140.36 40.89 145.58 49.3L151.67 67.57C151.67 67.57 156.02 94.83 144.71 115.42C127.31 147.03 98.31 150.51 98.31 150.51Z" fill="white" stroke="#808DA0"/>
        <path d="M140.65 42.92L70.7599 66.41" stroke="#808DA0"/>
        <path d="M98.89 49.59L124.12 41.76" stroke="#808DA0" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M107.88 147.9L84.39 76.85C83.81 75.4 84.68 73.95 86.13 73.37L147.9 52.78C147.9 52.78 159.21 82.94 147.32 111.07C135.72 137.75 107.88 147.9 107.88 147.9Z" fill="#E6E8EC" stroke="#808DA0"/>
        <path d="M17.98 116.58C12.18 106.14 8.69995 93.96 8.69995 81.2C8.69995 41.18 41.18 8.69995 81.2 8.69995C121.22 8.69995 153.7 41.18 153.7 81.2C153.7 121.22 121.22 153.7 81.2 153.7C64.09 153.7 48.43 147.9 35.96 137.75" stroke="#808DA0" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
        </svg>

        <svg width="174" height="174" viewBox="0 0 174 174" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M159.5 89.9C159.5 128.47 128.47 159.5 89.9 159.5C51.33 159.5 20.3 128.47 20.3 89.9C20.3 51.33 51.33 20.3 89.9 20.3C128.47 20.3 159.5 51.33 159.5 89.9Z" fill="#EAECEE"/>
        <path d="M82.65 111.36L80.33 62.35C80.33 61.19 79.17 60.32 78.01 60.61C77.14 60.9 76.56 61.48 76.56 62.64L78.59 111.65C78.59 112.52 79.17 113.39 80.33 113.39C81.78 113.68 82.65 112.52 82.65 111.36Z" fill="#B3BBC6" stroke="#808DA0" strokeWidth="0.8"/>
        <path d="M73.95 98.89C73.37 101.21 71.05 103.53 72.79 105.56C74.82 108.17 76.27 113.1 78.01 115.13C81.78 119.19 87.87 118.03 92.51 123.83C94.25 126.44 99.18 130.79 114.55 144.13L124.41 136.88L133.11 129.05L104.4 113.1C100.63 101.21 90.19 89.9 80.62 82.65C75.4 84.97 89.61 96.86 86.42 95.99C86.42 95.99 74.82 84.97 71.92 88.45C70.76 89.9 73.66 91.64 73.37 92.8C73.08 93.38 71.34 93.38 71.05 94.25C71.05 95.7 74.24 97.73 73.95 98.89Z" fill="white" stroke="#808DA0" strokeWidth="0.8"/>
        <path d="M142.68 118.9C141.52 117.45 140.36 113.39 140.36 110.49C140.07 107.59 141.23 101.79 138.33 102.66C135.43 103.24 122.38 105.85 118.9 104.11C115.42 102.37 118.61 97.44 118.61 97.44C118.61 97.44 116.29 94.25 116.29 93.09C116.29 92.22 117.74 91.06 117.74 90.19C117.74 89.32 115.42 88.16 115.13 87.29C114.84 85.84 116 83.52 114.55 80.91C113.39 78.3 109.62 80.04 107.59 77.43C105.56 74.82 114.84 66.12 116.58 62.06C118.9 56.84 115.71 54.81 117.16 48.43C118.61 40.6 122.96 36.54 118.32 35.96C112.23 34.8 125.57 24.36 125.57 24.36C125.57 24.36 141.23 40.02 144.71 46.69C148.48 54.23 152.54 71.34 153.12 79.75C154.86 94.25 142.68 118.9 142.68 118.9Z" fill="white" stroke="#808DA0"/>
        <path d="M17.98 116.58C12.18 106.14 8.70001 93.96 8.70001 81.2C8.70001 41.18 41.18 8.69995 81.2 8.69995C121.22 8.69995 153.7 41.18 153.7 81.2C153.7 121.22 121.22 153.7 81.2 153.7C64.09 153.7 48.43 147.9 35.96 137.75" stroke="#808DA0" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
        </svg>
      </div>

      <div className={uni.spacerBig}/>
      <div className={uni.spacer}/>
      <div className={uni.checkboxContainer} onClick={handleCheckTerms}>
        {checkbox(checkTerms)}
        <div className={uni.smallText}>
          {getLang(LangIds.ACCEPT_Terms1, lang)}
          <u>{getLang(LangIds.ACCEPT_Terms2, lang)}</u>
          {getLang(LangIds.ACCEPT_Terms3, lang)}
          <u>{getLang(LangIds.ACCEPT_Terms4, lang)}</u>
          {getLang(LangIds.ACCEPT_Terms5, lang)}
        </div>
      </div>
      {error(checkTerms===Check.EMPHASIZED, getLang(LangIds.ACCEPT_ErrAccept, lang))}
      <div className={uni.spacer} id='checkTermsSpacer'/>
      <div className={uni.checkboxContainer} onClick={handleCheckShare}>
        {checkbox(checkShare)}
        <div className={uni.smallText}>{getLang(LangIds.ACCEPT_Sharing, lang)}</div>
      </div>
      <div className={uni.filler}/>
      <button className={uni.button} type="button" onClick={handleClick}>{getLang(LangIds.BUTTON_Continue, lang)}</button>
      {logo(getLang(LangIds.LOGO_Powered, lang))}
    </div>
    </>
  );
}

export default AcceptTerms;
